// extracted by mini-css-extract-plugin
module.exports = {"advertisementLabel":"styles_advertisementLabel__uUzHi"};